export default "__VITE_ASSET__Bse5XU1h__"